import { useEffect, useMemo, useState } from 'react'
import { translations } from '../../../../configs/translations'
import { useStore } from '../../../../store/store'
import { getTimeFormated } from '../../../../utils/getTimeFormated'
import './EventCountdown.css'

export const EventCountdown = ({ remaining }: { remaining: number }) => {
	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]

	const [targetTime, setTargetTime] = useState(Date.now() + remaining)
	const [now, setNow] = useState(Date.now())

	useEffect(() => {
		setTargetTime(Date.now() + remaining)
	}, [remaining])

	useEffect(() => {
		const interval = window.setInterval(() => {
			setNow(Date.now())
		}, 1000)

		return () => window.clearInterval(interval)
	}, [])

	const timeFormatted = useMemo(() => {
		const remainingUntilEndSafe = Math.max(0, targetTime - now)

		const remainingMinutes = Math.floor(remainingUntilEndSafe / 60000)
		const remainingSeconds = Math.floor((remainingUntilEndSafe % 60000) / 1000)

		return getTimeFormated(null as never, remainingMinutes, remainingSeconds).split(',')[0]
	}, [targetTime, now])

	return (
		<div className="event-countdown">
			<p>{t.event_ends_in}: <span className='weight-400'>{timeFormatted}</span></p>
		</div>
	)
}